import type { AnchorHTMLAttributes, MouseEvent } from 'react';
import { navigate } from '../lib/router';

type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & { to: string; section?: string };

/* An internal link: a real <a href> (middle click, copy link and crawlers work), navigated without a reload. */
const Link = ({ to, section, onClick, children, ...rest }: LinkProps) => (
    <a
        href={to}
        onClick={(event: MouseEvent<HTMLAnchorElement>) => {
            onClick?.(event);
            if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            navigate(to, { section });
        }}
        {...rest}
    >
        {children}
    </a>
);

export default Link;
